import React from 'react';
import SmartComponent from '../../../utils/smart-component';

export interface INoTimesheetsRowProps {
    message?: string;
}

const useInitialState = ({ message = 'Loading...' }: INoTimesheetsRowProps): INoTimesheetsRowProps => ({
    message,
});

const renderDesktop = ({ message = 'Loading...' }: INoTimesheetsRowProps): JSX.Element => (
    <p className="text-center m-3">{message}</p>
);

const renderMobile = ({ message = 'Loading...' }: INoTimesheetsRowProps): JSX.Element => (
    <p className="mobile__body text-center m-3">{message}</p>
);

export { renderDesktop as NoTimesheetsDesktop, renderMobile as NoTimesheetsMobile };

export default SmartComponent<INoTimesheetsRowProps, INoTimesheetsRowProps>(
    useInitialState,
    renderDesktop,
    renderMobile,
);
